(function () {
  'use strict';

  window.SRS = window.SRS || {};

  const calendar = {
    
    section: null,

    initialized: false,

    currentDate: new Date(),

    lastGuestCount: null,

    lastProductCode: "",

    stateChangeHandler: null,

    closedNotice: "",

    slots: {
        lunch: [
            { time: "11:30", status: "available" },
            { time: "12:00", status: "available" },
            { time: "12:30", status: "available" },
            { time: "13:00", status: "available" }
        ],
        dinner: [
            { time: "16:30", status: "available" },
            { time: "17:00", status: "available" },
            { time: "17:30", status: "available" },
            { time: "18:00", status: "available" },
            { time: "18:30", status: "available" },
            { time: "19:00", status: "available" },
            { time: "19:30", status: "available" },
            { time: "20:00", status: "available" }
        ]
    },

    init(section) {

        this.section = section;

        this.slotsUrl =
            section.dataset.slotsUrl || "";

        this.lastGuestCount =
            window.SRS.state.getTotalGuests();

        this.lastProductCode =
            window.SRS.state.getState().product?.code || "";

        this.render();
        this.renderDateInstruction();

        if (!this.initialized) {
            this.bindEvents();
            this.bindStateChanges();
            this.initialized = true;
        }

    },

    bindEvents() {
        document.addEventListener('click', (e) => {
            const dayButton =
            e.target.closest('.srs-calendar__day');

            if (
                dayButton &&
                !dayButton.classList.contains('is-disabled')
            ) {
                if (dayButton.dataset.calendarPhone === 'true') {
                    this.openPhoneDialog();
                    return;
                }

                this.selectDay(dayButton);
            }

            const slotButton =
            e.target.closest('.srs-slot');

            if (
                slotButton &&
                !slotButton.disabled &&
                !slotButton.classList.contains('srs-slot--full') &&
                !slotButton.classList.contains('srs-slot--closed')
            ) {
                this.selectSlot(slotButton);
            }

            if (e.target.matches('[data-calendar-prev]')) {
            this.changeMonth(-1);
            }

            if (e.target.matches('[data-calendar-next]')) {
            this.changeMonth(1);
            }
        });
    },

    bindStateChanges() {

        this.stateChangeHandler = (event) => {

            const state = event.detail;

            if (!state) return;

            const productCode =
                state.product?.code || "";

            if (productCode !== this.lastProductCode) {
                this.lastProductCode = productCode;

                this.section
                    .querySelectorAll(".srs-calendar__day")
                    .forEach((day) => {
                        day.classList.remove("is-selected");
                    });

                this.renderDateInstruction();
                return;
            }

            const guestCount =
                Number(state.guests?.adults || 0) +
                Number(state.guests?.children || 0);

            if (guestCount === this.lastGuestCount) {
                return;
            }

            this.lastGuestCount = guestCount;

            const selectedDate =
                state.reservation?.date;

            if (!selectedDate) {
                return;
            }

            this.loadSlots(selectedDate);
        };

        document.addEventListener(
            "srs:statechange",
            this.stateChangeHandler
        );

    },

    getTokyoTodayText() {
        return new Intl.DateTimeFormat("en-CA", {
            timeZone: "Asia/Tokyo",
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
        }).format(new Date());
    },

    addDays(dateText, days) {
        const [year, month, day] =
            String(dateText).split("-").map(Number);

        const date = new Date(
            Date.UTC(year, month - 1, day),
        );

        date.setUTCDate(
            date.getUTCDate() + Number(days || 0),
        );

        return [
            date.getUTCFullYear(),
            String(date.getUTCMonth() + 1).padStart(2, "0"),
            String(date.getUTCDate()).padStart(2, "0"),
        ].join("-");
    },

    formatJapaneseDate(dateText) {
        const [year, month, day] =
            String(dateText).split("-").map(Number);

        return `${year}年${month}月${day}日`;
    },

    getProductReservationRule() {
        const product =
            window.SRS.state.getState().product || {};

        const minimumDaysBefore = Math.max(
            0,
            Number(product.minimumDaysBefore || 0),
        );

        const subject =
            product.type === "course"
                ? "このコース"
                : product.type === "hotpot"
                    ? "この商品"
                    : "このプラン";

        const earliestDate = this.addDays(
            this.getTokyoTodayText(),
            minimumDaysBefore,
        );

        return {
            minimumDaysBefore,
            earliestDate,
            subject,
        };
    },

    getOrCreateLeadTimeNotice() {
        let notice = this.section.querySelector(
            "[data-product-lead-time-notice]",
        );

        if (notice) return notice;

        notice = document.createElement("div");
        notice.dataset.productLeadTimeNotice = "";
        notice.setAttribute("role", "alert");
        notice.className = "srs-lead-time-card";
        notice.hidden = true;

        const slotList = this.section.querySelector(
            "[data-slot-list]",
        );

        if (slotList) {
            slotList.innerHTML = "";
            slotList.appendChild(notice);
        }

        return notice;
    },

    showLeadTimeNotice(rule) {
        const notice =
            this.getOrCreateLeadTimeNotice();

        const earliestLabel =
            this.formatJapaneseDate(rule.earliestDate);

        const [, earliestMonth, earliestDay] =
            String(rule.earliestDate)
                .split("-")
                .map(Number);

        notice.innerHTML = `
            <div class="srs-lead-time-card__eyebrow">
                <span aria-hidden="true">📅</span>
                <span>最短予約可能日</span>
            </div>

            <div class="srs-lead-time-card__date">
                ${earliestLabel}
            </div>

            <p class="srs-lead-time-card__text">
                ${rule.subject}は${rule.minimumDaysBefore}日前までのご予約です。<br>
                ${earliestMonth}月${earliestDay}日以降、またはほかのプランをお選びください。
            </p>
        `;

        notice.hidden = false;
        requestAnimationFrame(() => {
            notice.classList.add("is-visible");
        });
    },

    hideLeadTimeNotice() {
        const notice = this.section.querySelector(
            "[data-product-lead-time-notice]",
        );

        if (notice) {
            notice.classList.remove("is-visible");

            window.setTimeout(() => {
                if (!notice.classList.contains("is-visible")) {
                    notice.hidden = true;
                    notice.innerHTML = "";
                }
            }, 200);
        }
    },

    openLeadTimeDialog(rule) {
        let dialog = document.querySelector(
            "[data-srs-lead-time-dialog]",
        );

        if (!dialog) {
            dialog = document.createElement("dialog");
            dialog.className = "srs-phone-dialog";
            dialog.dataset.srsLeadTimeDialog = "";

            document.body.appendChild(dialog);

            dialog.addEventListener("click", (event) => {
                if (
                    event.target === dialog ||
                    event.target.closest(
                        "[data-srs-lead-time-dialog-close]",
                    )
                ) {
                    dialog.close();
                }
            });
        }

        const earliestLabel =
            this.formatJapaneseDate(rule.earliestDate);

        const earliestDay =
            Number(String(rule.earliestDate).slice(-2));

        dialog.innerHTML = `
            <div class="srs-phone-dialog__content srs-lead-time-dialog">
                <button
                    type="button"
                    class="srs-phone-dialog__close"
                    data-srs-lead-time-dialog-close
                    aria-label="閉じる"
                >
                    ×
                </button>

                <div class="srs-lead-time-dialog__eyebrow">
                    <span aria-hidden="true">📅</span>
                    <span>最短予約可能日</span>
                </div>

                <div class="srs-lead-time-dialog__date">
                    ${earliestLabel}
                </div>

                <p class="srs-lead-time-dialog__reason">
                    ${rule.subject}は${rule.minimumDaysBefore}日前までのご予約となります。
                </p>

                <p class="srs-lead-time-dialog__guide">
                    ${earliestDay}日以降の日付、またはほかのプランをお選びください。
                </p>

                <button
                    type="button"
                    class="srs-phone-dialog__button"
                    data-srs-lead-time-dialog-close
                >
                    閉じる
                </button>
            </div>
        `;

        dialog.showModal();
    },

    renderDateInstruction() {
        this.hideLeadTimeNotice();

        const slotList = this.section.querySelector(
            "[data-slot-list]",
        );

        if (slotList) {
            slotList.innerHTML = `
                <p class="srs-slots__loading">
                    ご利用日を選択すると、予約可能な時間が表示されます。
                </p>
            `;
        }
    },

    blockSlotsForLeadTime() {
        const slotList = this.section.querySelector(
            "[data-slot-list]",
        );

        if (slotList) {
            slotList.innerHTML = "";
        }
    },

    changeMonth(offset) {

            this.currentDate = new Date(
                this.currentDate.getFullYear(),
                this.currentDate.getMonth() + offset,
                1
            );

            this.render();

            },

        async loadSlots(date) {

            if (!this.slotsUrl) {
                console.error("SRS slots URL is missing.");
                return;
            }

            const slotList = this.section.querySelector(
                "[data-slot-list]"
            );

            if (slotList) {
                slotList.innerHTML = `
                    <p class="srs-slots__loading">
                        空き状況を確認しています...
                    </p>
                `;
            }

            try {
                const guestCount =
                    window.SRS.state.getTotalGuests();

                const response = await fetch(
                    `${this.slotsUrl}?date=${encodeURIComponent(date)}&guests=${guestCount}`
                );

                const data = await response.json();

                console.log("SRS Slots:", data);

                if (!response.ok || data.success !== true) {
                    throw new Error(
                        data.error || "Failed to load slots"
                    );
                }

                this.closedNotice =
                    data.closed === true
                        ? String(
                            data.notice ||
                            "休業日のため、予約を受け付けておりません。"
                          )
                        : "";

                this.slots = {
                    lunch: data.slots
                        .filter((slot) => slot.session === "lunch")
                        .map((slot) => ({
                            time: slot.time,
                            status: slot.status
                        })),

                    dinner: data.slots
                        .filter((slot) => slot.session === "dinner")
                        .map((slot) => ({
                            time: slot.time,
                            status: slot.status
                        }))
                };

                const selectedTime =
                    window.SRS.state.getState().reservation?.time || "";

                if (selectedTime) {
                    const selectedSlot = [
                        ...this.slots.lunch,
                        ...this.slots.dinner,
                    ].find((slot) => slot.time === selectedTime);

                    const remainsAvailable =
                        selectedSlot &&
                        ["available", "few"].includes(selectedSlot.status);

                    if (!remainsAvailable) {
                        window.SRS.state.setTime("");
                    }
                }

                this.renderSlots();

            } catch (error) {
                console.error(
                    "Failed to load SRS slots:",
                    error
                );

                if (slotList) {
                    slotList.innerHTML = `
                        <p class="srs-slots__error">
                            空き状況を取得できませんでした。<br>
                            しばらくしてから、もう一度お試しください。
                        </p>
                    `;
                }
            }

        },


    renderSlots() {

    const slotList = this.section.querySelector(
        "[data-slot-list]"
    );

    if (!slotList) return;

    const createSlot = (slot) => {

        const symbol = {
            available: "○",
            few: "△",
            full: "×",
            closed: "×"
        }[slot.status] || "×";

        const statusLabel = {
            full: "満席",
            closed: "受付終了"
        }[slot.status] || "";

        const selectedTime =
            window.SRS.state.getState().reservation?.time || "";

        const selectedClass =
            selectedTime === slot.time ? " is-selected" : "";

        return `
        <button
            type="button"
            class="srs-slot srs-slot--${slot.status}${selectedClass}"
            data-slot-time="${slot.time}"
            ${
                slot.status === "full" ||
                slot.status === "closed"
                    ? "disabled"
                    : ""
            }
        >
            <span class="srs-slot__main">${symbol} ${slot.time}</span>
            ${statusLabel ? `<span class="srs-slot__status-label">${statusLabel}</span>` : ""}
        </button>
        `;

    };

    const closedNoticeHtml = this.closedNotice
        ? `
            <div
                class="srs-slots__closed-notice"
                role="status"
            >
                <strong>休業日</strong>
                <span>${this.escapeHtml
                    ? this.escapeHtml(this.closedNotice)
                    : this.closedNotice.replace(/[&<>"']/g, (character) => ({
                        "&": "&amp;",
                        "<": "&lt;",
                        ">": "&gt;",
                        '"': "&quot;",
                        "'": "&#039;"
                    })[character])}</span>
            </div>
        `
        : "";

    slotList.innerHTML = `
        ${closedNoticeHtml}

        <div class="srs-slot-group">

        <h4 class="srs-slot-group__title">
            ランチ
        </h4>

        <div class="srs-slots__list">

            ${this.slots.lunch.map(createSlot).join("")}

        </div>

        </div>

        <div class="srs-slot-group">

        <h4 class="srs-slot-group__title">
            ディナー
        </h4>

        <div class="srs-slots__list">

            ${this.slots.dinner.map(createSlot).join("")}

        </div>

        </div>
    `;

    },

    render() {
        this.renderHeader();
        this.renderCalendar();
        this.renderSlots();
        },

        async selectDay(button) {
            this.section
                .querySelectorAll(".srs-calendar__day")
                .forEach((day) => {
                    day.classList.remove("is-selected");
                });

            const selectedDate =
                button.getAttribute("data-calendar-date");

            if (!selectedDate) return;

            const rule =
                this.getProductReservationRule();

            if (
                rule.minimumDaysBefore > 0 &&
                selectedDate < rule.earliestDate
            ) {
                window.SRS.state.setDate("");
                this.blockSlotsForLeadTime(rule);
                this.showLeadTimeNotice(rule);
                return;
            }

            this.hideLeadTimeNotice();
            button.classList.add("is-selected");

            window.SRS.state.setDate(selectedDate);

            await this.loadSlots(selectedDate);
        },

    openPhoneDialog() {

        let dialog =
            document.querySelector('[data-srs-phone-dialog]');

        if (!dialog) {

            dialog = document.createElement('dialog');

            dialog.className = 'srs-phone-dialog';
            dialog.dataset.srsPhoneDialog = '';

            dialog.innerHTML = `
                <div class="srs-phone-dialog__content">

                    <button
                        type="button"
                        class="srs-phone-dialog__close"
                        data-srs-phone-dialog-close
                        aria-label="閉じる"
                    >
                        ×
                    </button>

                    <div class="srs-phone-dialog__icon">
                        📞
                    </div>

                    <h3 class="srs-phone-dialog__title">
                        当日のご予約について
                    </h3>

                    <p class="srs-phone-dialog__text">
                        当日のオンライン予約は承っておりません。
                    </p>

                    <p class="srs-phone-dialog__text">
                        当日のご予約をご希望のお客様は、<br>
                        お電話にてお問い合わせください。
                    </p>

                    <a
                        class="srs-phone-dialog__tel"
                        href="tel:09032369066"
                    >
                        090-3236-9066
                    </a>

                    <button
                        type="button"
                        class="srs-phone-dialog__button"
                        data-srs-phone-dialog-close
                    >
                        閉じる
                    </button>

                </div>
            `;

            document.body.appendChild(dialog);

            dialog.addEventListener('click', (event) => {

                if (
                    event.target === dialog ||
                    event.target.closest(
                        '[data-srs-phone-dialog-close]'
                    )
                ) {
                    dialog.close();
                }

            });

        }

        dialog.showModal();

    },
    

    selectSlot(button) {
        this.section
            .querySelectorAll('.srs-slot')
            .forEach((slot) => {
                slot.classList.remove('is-selected');
            });

        button.classList.add('is-selected');

        const selectedTime =
            button.getAttribute('data-slot-time');

        if (!selectedTime) return;

        window.SRS.state.setTime(selectedTime);
    },

    renderHeader() {

      const title = this.section.querySelector(
        '.srs-calendar__title'
        );

      if (!title) return;

      title.textContent =
        `${this.currentDate.getFullYear()}年${this.currentDate.getMonth()+1}月`;

    },

    renderCalendar() {

    const today = new Date();

    today.setHours(0,0,0,0);

      const grid = this.section.querySelector(
        '[data-calendar-grid]'
        );

      if (!grid) return;

      grid.innerHTML = '';

      const year = this.currentDate.getFullYear();
      const month = this.currentDate.getMonth();

      const firstDay =
        new Date(year, month, 1).getDay();

      const lastDate =
        new Date(year, month + 1, 0).getDate();



      for(let day=1;day<=lastDate;day++){

        const date = new Date(year,month,day);

        date.setHours(0,0,0,0);

        const cell=document.createElement('button');

        cell.type='button';

        cell.className =
        'srs-calendar__day srs-calendar__day--available';

        if (day === 1) {
        cell.style.gridColumnStart =
            String(firstDay + 1);
        }

        cell.dataset.calendarDate =
        `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;

        if (date < today) {

            cell.classList.add('is-disabled');
            cell.disabled = true;

        }

        if (date.getTime() === today.getTime()) {

            cell.classList.add('is-today');
            cell.classList.add('is-phone-reservation');
            cell.dataset.calendarPhone = 'true';

        }

        const isToday =
            date.getTime() === today.getTime();

        cell.innerHTML = `
            <span class="srs-calendar__day-number">${day}</span>
            <span class="srs-calendar__status">
                ${isToday ? '📞' : '○'}
            </span>
        `;

        grid.appendChild(cell);

      }

    }

  };

  window.SRS.calendar = calendar;

})();